// src/layout/MasterLayout.tsx
import React from 'react';
import Sidebar from '../components/Sidebar';
import ChatScreen from '../components/ChatScreen';
import { ChatProvider } from '../context/ChatContext';

const MasterLayout = () => {
  return (
    <ChatProvider>
      <div>
        <Sidebar />
        <ChatScreen />
      </div>
    </ChatProvider>
  );
};

export default MasterLayout;
